import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MessageTemplate } from '../../../../../../../shared/models/configuration.model';
import { MatDivider } from '@angular/material/divider';
import { MessageTemplateEditorComponent } from '../../message-template-editor/message-template-editor.component';

@Component({
  selector: 'app-manage-templates',
  imports: [MatDialogContent, MatDialogTitle, MatDialogActions, MatButton, MatDialogClose, MatDivider, MessageTemplateEditorComponent],
  templateUrl: './manage-templates.component.html',
  styleUrl: './manage-templates.component.scss',
})
export class ManageTemplatesComponent {

  newTemplate: MessageTemplate = null;
  templates: MessageTemplate[];

  constructor(
    public dialogRef: MatDialogRef<ManageTemplatesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MessageTemplate[]
  ) {
    this.templates = Object.assign([], data);
  }

  createTemplate() {
    this.newTemplate = new MessageTemplate();
    this.newTemplate.title = '';
  }

  newTemplateSaved(savedTemplate: MessageTemplate) {
    this.templates.push(savedTemplate);
    this.newTemplate = null;
  }

  newTemplateCanceled() {
    this.newTemplate = null;
  }

  deleteTemplate(index: number) {
    this.templates.splice(index, 1);
  }

  updateTemplate(index: number, template: MessageTemplate) {
    this.templates[index] = template;
  }
}
